jQuery(function($) {
    $('[data-toggle="popover"]').popover({
        html: true,
        placement: 'bottom',
        content: function() {
            return $('.brand-filter-popover').html();
        }
    });
});